<template>
  <!-- Import result: the honest account of what the upload did -->
  <Dialog v-model:visible="visible" modal header="Score Upload Result" class="w-full max-w-2xl">
    <template v-if="result">
      <p class="font-semibold mb-2 text-sm" :class="result.success ? 'text-green-700' : 'text-red-600'"
        data-testid="score-result-message">
        <i :class="result.success ? 'pi pi-check-circle' : 'pi pi-times-circle'" class="mr-1"></i>
        {{ result.message }}
      </p>

      <DataTable v-if="result.summary?.issues?.length" :value="result.summary.issues" size="small"
        class="p-datatable-sm mb-2" scrollable scrollHeight="240px" data-testid="score-result-issues">
        <Column field="row" header="Row" style="width: 70px" />
        <Column field="student_ref" header="Student" style="width: 160px" />
        <Column field="reason" header="Why it was skipped" />
      </DataTable>

      <div class="flex flex-wrap items-center gap-2">
        <Button v-if="result.summary?.issues?.length" label="Download skipped rows" icon="pi pi-download"
          size="small" severity="secondary" outlined data-testid="btn-download-skipped" @click="emit('download-issues')" />
        <router-link v-if="result.success && viewScoresRoute" :to="viewScoresRoute">
          <Button label="View the scores you just uploaded" icon="pi pi-arrow-right" size="small" outlined
            data-testid="btn-view-uploaded-scores" @click="visible = false" />
        </router-link>
      </div>
    </template>
    <template #footer>
      <Button label="Close" size="small" text @click="visible = false" />
    </template>
  </Dialog>
</template>

<script setup lang="ts">
import type { RouteLocationRaw } from 'vue-router';
import type { ScoreImportResult } from '@/composables/useScoreEntry';

defineProps<{
  result: ScoreImportResult | null;
  viewScoresRoute?: RouteLocationRaw | null;
}>();

const emit = defineEmits<{ 'download-issues': [] }>();

const visible = defineModel<boolean>('visible', { required: true });
</script>
